"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTransitionableDeletable = void 0;
var _Transitionable = require("./Transitionable.hook");
var useTransitionableDeletable = exports.useTransitionableDeletable = function useTransitionableDeletable(userId, transitionable, roleIds) {
  var allowOwnerInPendingToSend = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var sendable = (0, _Transitionable.useTransitionableSendable)(userId, transitionable, roleIds, allowOwnerInPendingToSend);
  return sendable;
};